import RegistrateForm from 'components/RegistrateForm';

const RegistratePage = () => {
  return <RegistrateForm />;
};

export default RegistratePage;
